import type {
  LookalikeSchema,
  LookalikeWeightUpdate,
  WeightedValue,
} from '@repo/contracts';

/**
 * Applies weight-slider edits to a schema, returning a new one — shared by
 * `apps/api`'s `PersonaLookalikesService.updateWeights` and `apps/web`'s
 * optimistic re-sample (`use-persona-lookalikes.ts`), so a slider drag
 * computes *exactly* what the server will persist a moment later. Throws for
 * an unknown value the same way on both sides, rather than each
 * re-implementing the check and risking the two disagreeing.
 */
export function applyWeightUpdates(
  schema: LookalikeSchema,
  updates: readonly LookalikeWeightUpdate[],
): LookalikeSchema {
  const next = structuredClone(schema);
  for (const update of updates) {
    const pool = next[update.field] as WeightedValue[];
    const entry = pool.find((candidate) => candidate.value === update.value);
    if (!entry) {
      throw new Error(`"${update.value}" is not a value in ${update.field}`);
    }
    entry.weight = update.weight;
  }
  return next;
}
